<template>
    <ion-content class="ion-padding">
        <ion-grid>
            <ion-row>
                <ion-col size="12" size-sm="6" offset-sm="3">
                    <h1>Export</h1>
                    <form @submit="exportData">
                        <!--input class="form-control" v-model="encryptionKey"/-->
                        <ion-button type="submit">Export to Json</ion-button>
                    </form>
                    <h1>Import</h1>
                    <form @submit="importData" method="post" enctype="multipart/form-data">
                        <!--input class="form-control" v-model="decryptionKey"/-->
                        <ion-item>
                            <input class="form-control" type="file" id="import-file"/>
                        </ion-item>
                        <ion-button type="submit">Import from Json</ion-button>

                    </form>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col size="12" size-sm="6" offset-sm="3">
                    <h1>Cache</h1>
                    <ion-button @click="deleteCache()">Cache Löschen</ion-button>
                </ion-col>
            </ion-row>
        </ion-grid>


    </ion-content>
</template>

<script>
    import {mapActions} from "vuex";
    import 'core-js/es6/array';

    export default {
        methods: {
            ...mapActions(["exportAction", "importAction", "deleteCacheAction"]),
            deleteCache(){
                this.deleteCacheAction();
            },
            exportData(e){
                e.preventDefault();
                this.exportAction(this.encryptionKey);
            },
            importData(e){
                e.preventDefault();
                let exportVue = this;
                let file = document.getElementById('import-file');
                if(file.files.length) {
                    var reader = new FileReader();
                    reader.onload = function(e) {
                        exportVue.importAction(
                            {
                                decryptionKey: exportVue.decryptionKey,
                                fileParam: file.files[0]
                            }
                        );
                    };
                    reader.readAsBinaryString(file.files[0], 'UTF-8');
                }
            }
        },
        data(){
            return {
                encryptionKey: '',
                decryptionKey: ''
            }
        },

    }
</script>

<style scoped>
    h1 {
        color: #B6B6B6;
        margin-top: 40px;
    }
    input {
        color: #B6B6B6;
    }
    ion-input,
    ion-item {
        --background: #3E4143;
        --color: #B6B6B6;
        --icon-color: #B6B6B6;
    }
    ion-button {
        margin-top: 30px;
    }
</style>